import { sortKeys } from "./object";

// Deterministically stringifies a given object
export const orderedStringify = obj => JSON.stringify(sortKeys(obj));
